import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const acceleration = new Quantity(
    quantityId.ACCELERATION,
    'Acceleration'
);

acceleration.registerUnit(
    new Unit(
        'mps2', 1, 'metre per second squared', [
            "m/s²", 'm/s^2'
        ]
    )
);

acceleration.registerUnit(
    new Unit(
        'ftps2', 3.28084, 'foot per second squared', [
            'ft/s²', 'ft/s^2'
        ]
    )
);

export default acceleration;